module.exports = __webpack_public_path__ + "static/img/banner.652de7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/gold/banner.png
// module id = ZXva
// module chunks = 1